var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"support"},[_c('div',{staticClass:"support-container"},[_c('div',{staticClass:"support-chat"},[_c('div',{staticClass:"support-chat-dialogs"},[_c('Dialogs')],1),_c('div',{staticClass:"support-chat-messages"},[_c('Messages')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }